module.exports = __webpack_public_path__ + "static/img/DailyCash.de15f37.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/DailyCash.gif
// module id = jMHp
// module chunks = 0